import { FC } from 'react';
import Head from 'next/head';

import {
  GMB_SOCIAL_LINKS,
  GMB_LOGO,
  GMB_SUPPORT_EMAIL,
  GMB_SUPPORT_PHONE_NUMBER,
  PROD_URL,
  AVERAGE_RATING,
  NUMBER_OF_REVIEWS,
} from '../../constants';

/**
 * The Organization schema should only be included on the homepage.
 */
const OrganizationSchema: FC = () => (
  <Head>
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Getmyboat',
          logo: GMB_LOGO,
          url: PROD_URL,
          sameAs: GMB_SOCIAL_LINKS,
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: GMB_SUPPORT_PHONE_NUMBER,
            email: GMB_SUPPORT_EMAIL,
            contactType: 'Customer service',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: AVERAGE_RATING,
            ratingCount: NUMBER_OF_REVIEWS,
          },
        }),
      }}
    />
  </Head>
);

export default OrganizationSchema;
